var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"animated-decimal-number"},[_c('animated-number',{attrs:{"value":_vm.integerPart,"formatter":_vm.format}}),_c('span',{staticClass:"decimal"},[_vm._v("."),_c('animated-number',{attrs:{"value":_vm.decimalPart,"formatter":_vm.format}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }